// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

export default function useServiceReasons() {
    const { data: reasonGroups = [] } = useApiSWRReference(
        '/service-reason-groups'
    )

    const reasons = reasonGroups.flatMap((group) => {
        return group.service_reasons.map((reason) => {
            return {
                ...reason,
                group_id: group.id,
                group_name: group.name,
            }
        })
    })

    return { reasonGroups, reasons }
}
